import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import DashboardPage from './pages/DashboardPage.vue'
import MallPage from './pages/mall/MallPage.vue'
import MallProductPage from './pages/mall/MallProductPage.vue'
import MallCartPage from './pages/mall/MallCartPage.vue'
import MallCartQuotePage from './pages/mall/MallCartQuotePage.vue'
import MallCheckoutPage from './pages/mall/MallCheckoutPage.vue'
import MallTossReturnPage from './pages/mall/MallTossReturnPage.vue'
import MallMyLayout from './components/mall/MallMyLayout.vue'
import MallMyHomePage from './pages/mall/MallMyHomePage.vue'
import MallMyClaimsPage from './pages/mall/MallMyClaimsPage.vue'
import MallMyStatementsPage from './pages/mall/MallMyStatementsPage.vue'
import MallMyReviewsPage from './pages/mall/MallMyReviewsPage.vue'
import MallInquiryWritePage from './pages/mall/MallInquiryWritePage.vue'
import MallMyProfilePage from './pages/mall/MallMyProfilePage.vue'
import MallOrdersPage from './pages/mall/MallOrdersPage.vue'
import MallOrderDetailPage from './pages/mall/MallOrderDetailPage.vue'
import MallWishlistPage from './pages/mall/MallWishlistPage.vue'
import MallShippingPage from './pages/mall/MallShippingPage.vue'
import MallStorePage from './pages/mall/MallStorePage.vue'
import MallTrackingPage from './pages/mall/MallTrackingPage.vue'
import MallHelpPage from './pages/mall/MallHelpPage.vue'
import LoginPage from './pages/LoginPage.vue'
import OAuthKakaoPage from './pages/OAuthKakaoPage.vue'
import MyInfoPage from './pages/MyInfoPage.vue'
import SignUpPage from './pages/SignUpPage.vue'
import FindIdPage from './pages/FindIdPage.vue'
import FindPasswordPage from './pages/FindPasswordPage.vue'
import TermsPage from './pages/TermsPage.vue'
import ConsultBoardListPage from './pages/ConsultBoardListPage.vue'
import ConsultBoardDetailPage from './pages/ConsultBoardDetailPage.vue'
import SellerDashboardPage from './pages/seller/SellerDashboardPage.vue'
import SellerOrdersPage from './pages/seller/SellerOrdersPage.vue'
import SellerClaimsPage from './pages/seller/SellerClaimsPage.vue'
import SellerProductsPage from './pages/seller/SellerProductsPage.vue'
import SellerSettlementsPage from './pages/seller/SellerSettlementsPage.vue'
import SellerReviewsPage from './pages/seller/SellerReviewsPage.vue'
import SellerSettingsPage from './pages/seller/SellerSettingsPage.vue'
import SellerOnboardingPage from './pages/seller/SellerOnboardingPage.vue'
import AdminDashboardPage from './pages/admin/AdminDashboardPage.vue'
import AdminProductsPage from './pages/admin/AdminProductsPage.vue'
import AdminProductEditPage from './pages/admin/AdminProductEditPage.vue'
import AdminDealsPage from './pages/admin/AdminDealsPage.vue'
import AdminSalesPage from './pages/admin/AdminSalesPage.vue'
import AdminOrdersPage from './pages/admin/AdminOrdersPage.vue'
import AdminSellersPage from './pages/admin/AdminSellersPage.vue'
import AdminSettingsPage from './pages/admin/AdminSettingsPage.vue'
import AdminSettlementsPage from './pages/admin/AdminSettlementsPage.vue'
import AdminLegalDocsPage from './pages/admin/AdminLegalDocsPage.vue'
import AdminContentSnippetsPage from './pages/admin/AdminContentSnippetsPage.vue'
import AdminSellerViewPage from './pages/admin/AdminSellerViewPage.vue'
import AdminMembersPage from './pages/admin/AdminMembersPage.vue'
import AdminCsPage from './pages/admin/AdminCsPage.vue'
import InfoCenterPage from './pages/info/InfoCenterPage.vue'
import InfoStoryPage from './pages/info/InfoStoryPage.vue'
import InfoPlazaPage from './pages/info/InfoPlazaPage.vue'
import InfoAccessGate from './pages/info/InfoAccessGate.vue'
import NotFoundPage from './pages/NotFoundPage.vue'
import ContractPage from './pages/ContractPage.vue'
import { memberHomeAfterLogin } from './composables/useLoginDestination'
import { safeMemberRedirect } from './utils/authRedirect'

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'dashboard', component: DashboardPage, meta: { visitLabel: '홈' } },
  /* 검은 메인으로 바뀐 뒤 남은 옛 포털 주소. 화면은 더 이상 열지 않는다. */
  { path: '/gate', redirect: '/' },
  { path: '/search', redirect: '/' },
  { path: '/announcements/:id', redirect: '/' },
  { path: '/announcements', redirect: '/' },
  {
    path: '/info',
    component: InfoAccessGate,
    meta: { visitLabel: '정보마당' },
    children: [
      { path: '', name: 'info-center', component: InfoCenterPage, meta: { visitLabel: '정보마당' } },
      { path: 'library', name: 'info-plaza', component: InfoPlazaPage, meta: { visitLabel: '정보마당 자료' } },
      { path: 'library/:code', redirect: (to) => `/info/${String(to.params.code || '')}` },
      { path: 'story/:idx', name: 'info-story', component: InfoStoryPage, meta: { visitLabel: '정보마당' } },
      { path: ':code', name: 'info-detail', component: InfoCenterPage, meta: { visitLabel: '정보마당' } },
    ],
  },
  { path: '/newsletters/:id', redirect: '/' },
  { path: '/newsletters', redirect: '/' },

  /* 구 소개 URL → 몰 홈 (북마크·외부 링크 유지) */
  { path: '/group-purchase', redirect: '/mall' },

  /* ---- 함우리몰 — 쇼핑몰 전용 레이아웃 ---- */
  { path: '/mall', name: 'mall', component: MallPage, meta: { layout: 'mall', requiresAuth: true, visitLabel: '함우리몰' } },
  {
    path: '/mall/tracking',
    name: 'mall-tracking',
    component: MallTrackingPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '배송조회' },
  },
  {
    path: '/mall/help',
    redirect: '/mall/help/guide',
  },
  {
    path: '/mall/help/:topic',
    name: 'mall-help',
    component: MallHelpPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '고객센터' },
  },
  {
    path: '/mall/support',
    redirect: '/mall/help/guide',
  },
  {
    path: '/mall/signup',
    name: 'mall-signup',
    component: SignUpPage,
    meta: { layout: 'mall', guestOnly: true, visitLabel: '회원가입' },
  },
  /* 함우리몰은 회원가입만 비회원에게 열려 있다. 상품·고객센터·배송조회부터 로그인이 필요하다. */
  {
    path: '/mall/cart',
    name: 'mall-cart',
    component: MallCartPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '장바구니' },
  },
  {
    path: '/mall/cart/quote',
    name: 'mall-cart-quote',
    component: MallCartQuotePage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '견적서' },
  },
  {
    path: '/mall/checkout',
    name: 'mall-checkout',
    component: MallCheckoutPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '주문/결제' },
  },
  {
    path: '/mall/checkout/toss-success',
    name: 'mall-toss-success',
    component: MallTossReturnPage,
    props: { outcome: 'success' },
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '결제 확인' },
  },
  {
    path: '/mall/checkout/toss-fail',
    name: 'mall-toss-fail',
    component: MallTossReturnPage,
    props: { outcome: 'fail' },
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '결제 실패' },
  },
  {
    /* 쿠팡형 마이쇼핑 — 주문·찜·배송지·리뷰·문의 등을 사이드바로 묶는다 */
    path: '/mall/mypage',
    component: MallMyLayout,
    meta: { layout: 'mall', requiresAuth: true, mypage: true, visitLabel: '마이쇼핑' },
    children: [
      {
        path: '',
        name: 'mall-mypage',
        component: MallMyHomePage,
        meta: { visitLabel: '마이쇼핑' },
      },
      {
        path: 'orders',
        name: 'mall-orders',
        component: MallOrdersPage,
        meta: { visitLabel: '주문목록' },
      },
      {
        path: 'claims',
        name: 'mall-claims',
        component: MallMyClaimsPage,
        meta: { visitLabel: '취소·반품·환불' },
      },
      {
        path: 'statements',
        name: 'mall-statements',
        component: MallMyStatementsPage,
        meta: { visitLabel: '거래명세서' },
      },
      {
        path: 'reviews',
        name: 'mall-reviews',
        component: MallMyReviewsPage,
        meta: { visitLabel: '리뷰 관리' },
      },
      {
        path: 'inquiries',
        redirect: '/mall/mypage/consults',
      },
      {
        path: 'consults',
        name: 'mall-inquiry-list',
        component: ConsultBoardListPage,
        meta: { visitLabel: '문의 내역' },
      },
      {
        path: 'consults/write',
        name: 'mall-inquiry-write',
        component: MallInquiryWritePage,
        meta: { visitLabel: '문의하기' },
      },
      {
        path: 'consults/:id',
        name: 'mall-inquiry-detail',
        component: ConsultBoardDetailPage,
        meta: { visitLabel: '문의 상세' },
      },
      {
        path: 'wishlist',
        name: 'mall-wishlist',
        component: MallWishlistPage,
        meta: { visitLabel: '찜 리스트' },
      },
      {
        path: 'shipping',
        name: 'mall-shipping',
        component: MallShippingPage,
        meta: { visitLabel: '배송지 관리' },
      },
      {
        path: 'profile',
        name: 'mall-profile',
        component: MallMyProfilePage,
        meta: { visitLabel: '개인정보' },
      },
    ],
  },
  {
    path: '/mall/inquiry/write',
    redirect: (to) => ({ path: '/mall/mypage/consults/write', query: to.query }),
  },
  {
    path: '/mall/inquiries/:id',
    redirect: (to) => `/mall/mypage/consults/${to.params.id}`,
  },
  { path: '/mall/inquiries', redirect: '/mall/mypage/consults' },
  {
    /* 결제(입금) 안내 겸 주문 상세. 상품 상세(/mall/:id)보다 먼저 잡아야 한다. */
    path: '/mall/orders/:code',
    name: 'mall-order-detail',
    component: MallOrderDetailPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '결제 내역' },
  },
  { path: '/mall/orders', redirect: '/mall/mypage/orders' },
  { path: '/mall/wishlist', redirect: '/mall/mypage/wishlist' },
  { path: '/mall/shipping', redirect: '/mall/mypage/shipping' },
  {
    path: '/mall/store/:code',
    name: 'mall-store',
    component: MallStorePage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '스토어' },
  },
  {
    path: '/mall/:id',
    name: 'mall-product',
    component: MallProductPage,
    meta: { layout: 'mall', requiresAuth: true, visitLabel: '함우리몰 상품' },
  },

  /* ---- 구 /group-purchase 하위 경로 → 함우리몰로 이관 ---- */
  { path: '/group-purchase/cart', redirect: '/mall/cart' },
  { path: '/group-purchase/checkout', redirect: '/mall/checkout' },
  { path: '/group-purchase/orders', redirect: '/mall/mypage/orders' },
  { path: '/group-purchase/wishlist', redirect: '/mall/mypage/wishlist' },
  { path: '/group-purchase/:id', redirect: (to) => `/mall/${to.params.id}` },

  /* ---- 판매관리센터 — 새 창으로 뜨는 독립 레이아웃 ---- */
  /* sellerTitle · sellerDesc 는 셸 상단바가 그대로 쓴다. */
  {
    path: '/seller',
    name: 'seller-dashboard',
    component: SellerDashboardPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '판매 대시보드',
      sellerDesc: '오늘의 판매 현황과 처리할 일을 한눈에 봅니다.',
    },
  },
  {
    path: '/seller/orders',
    name: 'seller-orders',
    component: SellerOrdersPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '주문 관리',
      sellerDesc: '택배사와 송장만 넣고 발송하면, 이후 진행은 자동으로 따라갑니다.',
    },
  },
  {
    path: '/seller/claims',
    name: 'seller-claims',
    component: SellerClaimsPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '취소 · 반품',
      sellerDesc: '접수된 요청을 승인하거나 반려합니다.',
    },
  },
  {
    path: '/seller/products',
    name: 'seller-products',
    component: SellerProductsPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '상품 관리',
      sellerDesc: '상품을 찍으면 옆에서 조회·재고·평점·검수를 처리합니다. 몰은 목록과 조건으로 가릅니다.',
    },
  },
  {
    path: '/seller/products/new',
    name: 'seller-product-new',
    redirect: () => ({ path: '/seller/products', query: { form: 'new' } }),
  },
  {
    path: '/seller/products/:id',
    name: 'seller-product-edit',
    redirect: (to) => ({
      path: '/seller/products',
      query: { form: String(to.params.id || '') },
    }),
  },
  {
    path: '/seller/settlements',
    name: 'seller-settlements',
    component: SellerSettlementsPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '정산 관리',
      sellerDesc: '구매확정된 건을 골라 정산 요청하고 엑셀로 받습니다.',
    },
  },
  {
    path: '/seller/reviews',
    name: 'seller-reviews',
    component: SellerReviewsPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '리뷰 · 문의',
      sellerDesc: '후기와 문의에 답변해 구매 전환을 높입니다.',
    },
  },
  {
    path: '/seller/onboarding',
    name: 'seller-onboarding',
    component: SellerOnboardingPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '입점 정보 등록',
      sellerDesc: '사업자 정보·약관 동의·서명을 마치면 검수를 요청합니다.',
      allowOnboarding: true,
    },
  },
  {
    path: '/seller/settings',
    name: 'seller-settings',
    component: SellerSettingsPage,
    meta: {
      layout: 'seller',
      requiresSeller: true,
      sellerTitle: '판매업체 정보',
      sellerDesc: '업체 · 정산 계좌 · 배송 정책을 관리합니다.',
    },
  },

  { path: '/wage/facility', redirect: '/' },
  { path: '/wage/visit', redirect: '/' },
  { path: '/facility', redirect: '/' },
  { path: '/visiting-care', redirect: '/' },
  { path: '/wage', redirect: '/' },
  { path: '/accounting', redirect: '/' },
  { path: '/services', redirect: '/' },
  { path: '/support', redirect: '/' },
  { path: '/faq', redirect: '/' },
  { path: '/notice/info', redirect: '/' },
  { path: '/notice', redirect: '/' },
  { path: '/consult-board/write', redirect: '/' },
  { path: '/consult-board/:id', redirect: '/' },
  { path: '/consult-board', redirect: '/' },
  /* 예전 관리자 로그인 주소는 같은 로그인 창으로 보낸다 */
  {
    path: '/admin/login',
    redirect: (to) => ({
      path: '/login',
      query: { ...to.query, tab: 'admin' },
    }),
  },
  {
    path: '/admin',
    name: 'admin-dashboard',
    component: AdminDashboardPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '관리자 대시보드',
      adminDesc: '입금 대기 · 검수 대기와 몰 현황을 한눈에 봅니다.',
    },
  },
  {
    path: '/admin/products',
    name: 'admin-products',
    component: AdminProductsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '상품관리',
      adminDesc: '판매 진행 · 몰 노출(특가·배지·할인)과 검수·숨김을 한곳에서 관리합니다.',
    },
  },
  {
    path: '/admin/products/:code',
    name: 'admin-product-edit',
    component: AdminProductEditPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '상품 관리 · 편집',
      adminDesc: '가격 · 노출 · 상세를 다듬고 판매·숨김·재검수를 처리합니다.',
    },
  },
  {
    path: '/admin/deals',
    name: 'admin-deals',
    component: AdminDealsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '이달의 특가',
      adminDesc: '몰 홈 히어로와 특가 레일에 올릴 상품을 지정합니다.',
    },
  },
  {
    path: '/admin/sales',
    name: 'admin-sales',
    component: AdminSalesPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '공동구매 특별할인',
      adminDesc: '공동구매몰을 여는 기간과 특별할인 이름을 관리합니다.',
    },
  },
  {
    path: '/admin/orders',
    name: 'admin-orders',
    component: AdminOrdersPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '주문 · 입금 확인',
      adminDesc: '통장 입금을 확인하고 판매업체로 주문을 넘깁니다.',
    },
  },
  {
    path: '/admin/sellers',
    name: 'admin-sellers',
    component: AdminSellersPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '판매업체',
      adminDesc: '입점 승인과 이용 상태를 관리합니다.',
    },
  },
  {
    path: '/admin/members',
    name: 'admin-members',
    component: AdminMembersPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '고객관리',
      adminDesc: '가입 기관과 주문 이력을 확인합니다.',
    },
  },
  {
    path: '/admin/cs',
    name: 'admin-cs',
    component: AdminCsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '문의 · 후기',
      adminDesc: '1:1 상담과 상품문의 답변, 구매후기 모니터링을 처리합니다.',
    },
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: AdminSettingsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '입금 계좌',
      adminDesc: '이전 계좌이체 주문에 안내하던 입금 계좌입니다. 새 주문은 토스페이먼츠로만 결제합니다.',
    },
  },
  { path: '/admin/announcements', redirect: '/' },
  {
    path: '/admin/info',
    redirect: '/info',
  },
  { path: '/admin/newsletters', redirect: '/' },
  { path: '/admin/faqs', redirect: '/' },
  {
    path: '/admin/legal-docs',
    name: 'admin-legal-docs',
    component: AdminLegalDocsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '약관 CMS',
      adminDesc: '판매·기관 약관 본문과 활성 버전을 관리합니다.',
    },
  },
  {
    path: '/admin/content-snippets',
    name: 'admin-content-snippets',
    component: AdminContentSnippetsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '화면 멘트',
      adminDesc: '몰·포털·판매 화면에 노출되는 안내 문구를 수정합니다.',
    },
  },
  {
    path: '/admin/seller-view',
    name: 'admin-seller-view',
    component: AdminSellerViewPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      requiresSuperAdmin: true,
      adminTitle: '판매업체 화면 보기',
      adminDesc: '최고관리자가 판매업체 아이디로 판매관리센터를 엽니다.',
    },
  },
  {
    // 기존 URL 호환용 리다이렉트 (취소·반품 승인/반려는 주문 페이지로 통합됨)
    path: '/admin/claims',
    redirect: (to) => ({
      name: 'admin-orders',
      query: { ...to.query, work: 'claim' },
    }),
  },
  {
    // 기존 URL 호환용 리다이렉트 (수동 환불 화면은 주문 페이지로 통합됨)
    path: '/admin/refunds',
    redirect: (to) => ({
      name: 'admin-orders',
      query: { ...to.query, work: 'refund' },
    }),
  },
  {
    path: '/admin/settlements',
    name: 'admin-settlements',
    component: AdminSettlementsPage,
    meta: {
      layout: 'admin',
      requiresAdmin: true,
      adminTitle: '판매업체 정산',
      adminDesc: '판매업체의 정산 요청을 확인하고 입금 완료로 표시합니다.',
    },
  },

  { path: '/login', name: 'login', component: LoginPage, meta: { guestOnly: true, visitLabel: '로그인' } },
  {
    path: '/oauth/kakao',
    name: 'oauth-kakao',
    component: OAuthKakaoPage,
    meta: { visitLabel: '카카오 로그인' },
  },
  { path: '/my-info', name: 'my-info', component: MyInfoPage, meta: { requiresAuth: true, visitLabel: '마이페이지' } },
  /* 공개 회원가입은 구매 일반회원만 받는다. 판매업체 계정은 관리자가 등록한다. */
  { path: '/signup', name: 'signup', component: SignUpPage, meta: { guestOnly: true, visitLabel: '회원가입' } },
  {
    path: '/signup/member',
    redirect: (to) => ({ name: 'signup', query: to.query }),
  },
  /* 판매업체 자가가입 폐지 — 관리자 등록 계정으로 로그인만 한다. */
  { path: '/signup/seller', redirect: { name: 'login', query: { tab: 'seller' } } },
  { path: '/find-id', name: 'find-id', component: FindIdPage, meta: { guestOnly: true, visitLabel: '아이디 찾기' } },
  { path: '/find-password', name: 'find-password', component: FindPasswordPage, meta: { visitLabel: '비밀번호 찾기' } },
  { path: '/terms/:type', name: 'terms', component: TermsPage, meta: { visitLabel: '약관' } },
  {
    path: '/계약서',
    name: 'contract',
    component: ContractPage,
    meta: { layout: 'bare', visitLabel: '계약서' },
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundPage, meta: { visitLabel: '404' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        window.setTimeout(() => {
          const el = document.querySelector(to.hash)
          if (el) {
            resolve({ el, behavior: 'smooth', top: 80 })
          } else {
            resolve({ top: 0 })
          }
        }, 420)
      })
    }
    return { top: 0, behavior: 'smooth' }
  },
})

async function resolveAuth() {
  const { useMemberAuth } = await import('@/composables/useMemberAuth')
  const auth = useMemberAuth()

  if (!auth.initialized.value) {
    await auth.initMemberAuth()
  }

  return auth
}

/**
 * 판매업체는 caion_mall_seller 의 자기 세션(jangi_seller_token)으로 움직인다.
 * 기관회원 세션과 쿠키가 달라, 한 브라우저에서 둘 다 로그인해 있어도 섞이지 않는다.
 */
async function resolveSellerAuth() {
  const { useSellerAuth } = await import('@/composables/useSellerAuth')
  const auth = useSellerAuth()

  if (!auth.initialized.value) {
    await auth.initSellerAuth()
  }

  return auth
}

/** 관리자는 caion_user 계정으로, 또 다른 쿠키(jangi_admin_token)로 움직인다. */
async function resolveAdminAuth() {
  const { useAdminAuth } = await import('@/composables/useAdminAuth')
  const auth = useAdminAuth()

  if (!auth.initialized.value) {
    await auth.initAdminAuth()
  }

  return auth
}

router.beforeEach(async (to, from) => {
  /*
   * 한글 경로(/계약서 등)는 브라우저가 pathname 을 %EA%B3%84… 형태로 둘 수 있다.
   * Vue Router 는 그 인코딩 문자열을 `/계약서` 라우트와 매칭하지 못해 404 가 난다.
   * 퍼센트 인코딩이 있으면 한 번 디코딩해 다시 맞춘다.
   */
  if (to.path.includes('%')) {
    try {
      const decodedPath = decodeURIComponent(to.path)
      if (decodedPath !== to.path) {
        return {
          path: decodedPath,
          query: to.query,
          hash: to.hash,
          replace: true,
        }
      }
    } catch {
      /* 잘못된 인코딩이면 그대로 진행 */
    }
  }

  /* 관리자 화면: 다른 세션은 보지 않는다 */
  if (to.meta.requiresAdmin) {
    const adminAuth = await resolveAdminAuth()
    if (!adminAuth.isAdminLoggedIn.value) {
      return { name: 'login', query: { tab: 'admin', redirect: to.fullPath } }
    }
    if (to.meta.requiresSuperAdmin && !adminAuth.isSuperAdmin.value) {
      return { name: 'admin-dashboard' }
    }
    return true
  }

  /* 판매관리센터: 기관회원 세션은 보지 않는다 */
  if (to.meta.requiresSeller) {
    const sellerAuth = await resolveSellerAuth()
    if (!sellerAuth.isSellerLoggedIn.value) {
      return { name: 'login', query: { tab: 'seller', redirect: to.fullPath } }
    }
    const mustOnboard = Boolean(sellerAuth.seller.value?.mustOnboard)
    if (mustOnboard && !to.meta.allowOnboarding) {
      return { name: 'seller-onboarding' }
    }
    if (!mustOnboard && to.name === 'seller-onboarding') {
      return { name: 'seller-dashboard' }
    }
    return true
  }

  const auth = await resolveAuth()

  /* 판매·관리자 입장은 기관회원으로 로그인한 상태에서도 같은 로그인 창에 남아 있어야 한다 */
  const isSellerLoginTab = to.name === 'login' && to.query.tab === 'seller'
  const isAdminLoginIntent =
    to.name === 'login' &&
    (to.query.tab === 'admin' ||
      (typeof to.query.redirect === 'string' && to.query.redirect.startsWith('/admin')))
  /* 로그인 화면에서 탭만 바꾸는 경우에는 홈으로 쫓아내지 않는다 */
  const isLoginTabSwitch = to.name === 'login' && from.name === 'login'
  const isSignupDone =
    (to.name === 'signup' || to.name === 'mall-signup') && to.query.done === '1'

  if (
    to.meta.guestOnly &&
    auth.isLoggedIn.value &&
    !isSellerLoginTab &&
    !isAdminLoginIntent &&
    !isLoginTabSwitch &&
    !isSignupDone
  ) {
    /* 함우리몰처럼 가려던 주소가 있으면 홈으로 되돌리지 않는다. */
    const next = router.resolve(safeMemberRedirect(to.query.redirect, memberHomeAfterLogin()))
    return {
      path: next.path,
      query: next.query,
      hash: next.hash,
      replace: true,
    }
  }

  const needsAuth = to.matched.some((record) => Boolean(record.meta.requiresAuth))
  if (!needsAuth) {
    return true
  }

  if (auth.isLoggedIn.value) {
    return true
  }

  /* 함우리몰은 기관회원만이 아니라, 로그인한 판매업체·관리자도 고객처럼 들어간다. */
  const isMall = to.matched.some((record) => record.meta.layout === 'mall')
  if (isMall) {
    const [adminAuth, sellerAuth] = await Promise.all([resolveAdminAuth(), resolveSellerAuth()])
    if (adminAuth.isAdminLoggedIn.value || sellerAuth.isSellerLoggedIn.value) {
      return true
    }
  }

  return {
    name: 'login',
    query: { redirect: to.fullPath },
  }
})


export default router
